import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface GiftPurchaseCheckingStatusState {
  gift_message_id: number;
}

const giftPurchaseCheckingStatus: Module<GiftPurchaseCheckingStatusState, RootState> = {
  namespaced: true,
  state: {} as GiftPurchaseCheckingStatusState,
  mutations: {
    setValue(state: GiftPurchaseCheckingStatusState, value: GiftPurchaseCheckingStatusState) {
      Object.assign(state, value);
    },
  },
  getters: {
    giftMessageId: (state: GiftPurchaseCheckingStatusState) => state.gift_message_id,
  },
};

export default giftPurchaseCheckingStatus;
